import { z } from "zod/v4";

import { UserRolesList } from "./users";

export const OrganizationListDtoSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  lastLoginTs: z.number().nullish(),
  shopId: z.string(),
  isInstalled: z.boolean(),
  createdAtTs: z.number().nullish(),
  roles: z.enum(UserRolesList).array(),
});

export type OrganizationListDto = z.infer<typeof OrganizationListDtoSchema>;
